module.exports = __webpack_public_path__ + "static/media/Done-4.0550370c.png";